import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    tracking: {
        tagmanager: {
            tagCode: 'GTM-5TKS3CG',
        },
    },
    host: 'www.zalando-prive.es',
});
